export const authors = 
[{
  bio: {
    about:  "",
    contact: "luis_mmartinez@live.com"
  },
  first_name: "Luis",
  id: 1,
  images: [
    {
      "id": 94,
      "alt": null,
      "caption": null,
      "format": null,
      "name": "profile_image.png",
      "s3key": null,
      "size": 23289,
      "url": "https://imgur.com/FNgZBZD.png"
    }
  ],
  last_name: "Martinez",
  username: "luismartinez"
}]